import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconBell.module.css';

const IconBell = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      viewBox="0 0 24 24"
      height="24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        strokeWidth="2"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </g>
    </svg>
  );
};

IconBell.defaultProps = { className: null, rootClassName: null };

IconBell.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconBell;
